module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              ARE YOU SURE YOU WANT TO DELETE AUTHOR ?\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.deleteAuthor
    }
  }, [_vm._v("\n                YES, DELETE\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button cancel-delete-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cd5d726"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalAuthordelete.vue
// module id = 672
// module chunks = 1